import React, { useEffect, useId } from 'react';

const SeoJsonLd = ({ data }) => {
  const id = useId();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `json-ld-${id}`;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const node = document.getElementById(`json-ld-${id}`);
      if (node) node.remove();
    };
  }, [id, JSON.stringify(data)]);

  return null;
};

export default SeoJsonLd;
